type supportedLocales = "en" | "fi" | "de" | "fr" | "es" | "id" | "pt"

export function stringWithoutLeadingSlash(str: string): string {
  return str.charAt(0) === "/" ? str.substring(1) : str
}

export function createLocalizedPath(locale: supportedLocales, pagePath: string = ""): string {
  const localeCode = locale === "en" ? "" : `/${locale}`
  return `${localeCode}/${stringWithoutLeadingSlash(pagePath)}`
}
